<template>
  <el-container class="project_list">
    <el-main>
      <div style="display: flex;justify-content: center;display:inline;">
        <el-select v-model="deptId" size="small" placeholder="选择机构" >
          <el-option label="全部" :key="0" :value="0"/>
          <el-option
            v-for="item in depts"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-input
          placeholder="通过关键字搜索项目..."
          prefix-icon="el-icon-search"
          v-model="name"
          style="width: 400px"
          size="mini"
        ></el-input>
        <el-input
          placeholder="通过建设单位搜索项目..."
          prefix-icon="el-icon-search"
          v-model="unit"
          style="width: 200px"
          size="mini"
        ></el-input>
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          style="margin-left: 3px"
          @click="searchClick"
        >搜索</el-button>
      </div>
      <div style="display: flex;justify-content: flex-start;margin-top:20px">
        <el-button type="primary" icon="el-icon-plus" size="mini" @click="addProject">添加</el-button>
        <el-button size="mini" @click="editProject(1)" v-if="showEdit">基本数据</el-button>
        <el-button size="mini" @click="editProject(2)" v-if="showEdit">财务数据</el-button>
        <el-button size="mini" @click="initialQuotaManage()" v-if="showEdit">定额管理</el-button>
        <el-button size="mini" @click="memberManage()" v-if="showEdit">项目成员</el-button>
        <el-button size="mini" @click="supplyManage()" v-if="showEdit">供货清单</el-button>
        <el-button size="mini" @click="supplyManage()" v-if="showEdit">设备清单</el-button>
        <el-button size="mini" @click="showAffixManageDialog()" v-if="showEdit">附件管理</el-button>
        <el-popconfirm style="margin-left:10px"
          placement="top"
          width="260"
          icon="el-icon-info"
          iconColor="red"
          title="确定要删除吗？"
          @onConfirm="del_project()">
          <div style="text-align: right; margin: 0">
            <el-button size="mini" type="text" @click="del_confirm_visible = false">取消</el-button>
            <el-button type="primary" size="mini" @click="del_confirm_visible = false">确定</el-button>
          </div>
          <el-button size="mini" type="danger" v-if="showDelete" slot="reference" @click="del_confirm_visible=true">删除</el-button>
        </el-popconfirm>
      </div>
      <el-table
        ref="multipleTable"
        :data="projects"
        tooltip-effect="dark"
        style="width: 100%;overflow-x: hidden; overflow-y: hidden;"
        max-height="560"
        @selection-change="handleSelectionChange"
        v-loading="loading"
      >
        <el-table-column type="selection" width="30" align="left"></el-table-column>
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="contractNo" label="合同编号" width="120" align="left"></el-table-column>
        <el-table-column prop="type" label="项目类别" width="130" align="left">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type == 0" type="success" >其他</el-tag>
            <el-tag v-if="scope.row.type == 1" type="success" >档案数字化</el-tag>
            <el-tag v-if="scope.row.type == 2" type="success">人事档案数字化</el-tag>
            <el-tag v-if="scope.row.type == 3" type="success">档案整理</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="deptName" label="项目部" width="120" align="left"></el-table-column>
        <el-table-column prop="unit" label="单位名称" width="180" align="left"></el-table-column>
        <el-table-column prop="name" label="项目名称" width="380" align="left" @click="itemClick"></el-table-column>
        <el-table-column prop="projectManagerName" label="项目经理" width="120" align="left"></el-table-column>
        <el-table-column prop="projectLeaderName" label="项目组长" width="120" align="left"></el-table-column>
        <el-table-column prop="status" label="项目状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag effect="dark" v-if="scope.row.status == 0" type="danger">待处理</el-tag>
            <el-tag v-if="scope.row.status == 1" type="success">正在进行</el-tag>
            <el-tag v-if="scope.row.status == 2" type="danger">暂停</el-tag>
            <el-tag v-if="scope.row.status == 3" type="success">放弃</el-tag>
            <el-tag effect="dark" v-if="scope.row.status == 4" type="success">完成</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="合同状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag effect="dark" v-if="scope.row.contractStatus == 0" type="danger">待签</el-tag>
            <el-tag effect="dark" v-if="scope.row.contractStatus == 1" type="success">已签</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="progress" label="项目进度">
            <template slot-scope="scope">
              <el-progress
                type="line"
                :stroke-width="15"
                :percentage="scope.row.progress"
                color="blue"
              ></el-progress>
            </template>
        </el-table-column>
      </el-table>
      <div class="guest_table_footer">
        <el-pagination
          background
          :page-size="pageSize"
          layout="prev, pager, next"
          :total="totalCount"
          @current-change="currentChange"
          v-show="this.projects&&this.projects.length>0"
        ></el-pagination>
      </div>
    </el-main>
    <el-dialog width="60%" height="600" :title="dlg_title" :visible.sync="dialogVisible" class="guest-dlg" :close-on-click-modal="false">
      <el-form label-width="90px" label-position="right" label-suffix="" :model="project">
        <el-row type="flex" :gutter="20">
          <el-col :span="12">
            <el-form-item label="项目名称">
              <el-input
                maxlength="50"
                v-model="project.name"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="项目单位">
              <el-input
                maxlength="50"
                v-model="project.unit"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系人">
              <el-input
                maxlength="50"
                v-model="project.procurementContacts"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话">
              <el-input
                maxlength="50"
                v-model="project.procurementTel"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="项目阶段">
              <el-select placeholder="请选择" size="mini" v-model="project.stage">
                <el-option
                  v-for="item in stages"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="项目类别">
              <el-select placeholder="请选择" size="mini" v-model="project.type">
                <el-option
                  v-for="item in projectType"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="项目状态">
              <el-select placeholder="请选择" size="mini" v-model="project.status">
                <el-option
                  v-for="item in status"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="代理机构">
              <el-input
                maxlength="30"
                v-model="project.biddingAgency"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="代理联系人">
              <el-input
                maxlength="30"
                v-model="project.biddingContacts"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="代理费">
              <el-input
                maxlength="30"
                v-model="project.biddingFee"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="代理费状态">
              <el-select placeholder="请选择" size="mini" v-model="project.biddingStatus">
                <el-option
                  v-for="item in biddingStatus"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="采购方式">
              <el-select placeholder="请选择" size="mini" v-model="project.procurementMethod">
                <el-option
                  v-for="item in procurementMethods"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="合同状态">
              <el-select placeholder="请选择" size="mini" v-model="project.contractStatus">
                <el-option
                  v-for="item in contractStatus"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="合同编号">
              <el-input
                maxlength="30"
                v-model="project.contractNo"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="签署日期">
              <el-input
                maxlength="11"
                v-model="project.signDate"
                auto-complete="off"
                size="mini"
                type="date"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="开工日期">
              <el-input
                maxlength="11"
                v-model="project.startDate"
                auto-complete="off"
                size="mini"
                type="date"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="完成日期">
              <el-input
                maxlength="11"
                v-model="project.completeDate"
                auto-complete="off"
                size="mini"
                type="date"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
           <el-col :span="6">
            <el-form-item label="项目部">
              <el-select placeholder="请选择" size="mini" v-model="project.dept">
                <el-option
                  @click.native="handleSelectTeam(item)"
                  v-for="item in depts"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="项目经理">
              <el-select placeholder="请选择" size="mini" v-model="project.projectManager">
                <el-option
                  v-for="item in projectManagers"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="项目组长">
              <el-select placeholder="请选择" size="mini" v-model="project.projectLeader">
                <el-option
                  v-for="item in users"
                  :key="item.id"
                  :label="item.loginName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="预分配人工">
              <el-input
                maxlength="11"
                v-model="project.assignLabor"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
           <el-col :span="6">
            <el-form-item label="数字化页数">
              <el-input
                maxlength="11"
                v-model="project.digitizationPage"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="数字化件数">
              <el-input
                maxlength="11"
                v-model="project.digitizationPiece"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="整理卷数">
              <el-input
                maxlength="11"
                v-model="project.reorganizeVolume"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="整理件数">
              <el-input
                maxlength="11"
                v-model="project.reorganizeFile"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="验收状态">
              <el-select placeholder="请选择" size="mini" v-model="project.acceptanceStatus">
                <el-option
                  v-for="item in acceptanceStatus"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="验收文档">
              <el-select placeholder="请选择" size="mini" v-model="project.acceptanceDoc">
                <el-option
                  v-for="item in acceptanceDoc"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="验收日期">
              <el-input
                maxlength="11"
                v-model="project.acceptanceDate"
                auto-complete="off"
                size="mini"
                type="date"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
         <el-col :span="12">
          <el-form-item label="合同执行注意事项">
              <el-input
                type="textarea"
                rows="8"
                maxlength="1000"
                v-model="project.contractContent"
                auto-complete="off"
              />
          </el-form-item>
         </el-col>
        <el-col :span="12">
          <el-form-item label="合同约定服务量">
              <el-input
                type="textarea"
                rows="8"
                maxlength="1000"
                v-model="project.serviceContent"
                auto-complete="off"
              />
          </el-form-item>
         </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="defualt" @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveProject">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog width="60%" height="600" :title="dlg_title" :visible.sync="dialogVisibleCw" class="guest-dlg" :close-on-click-modal="false">
      <el-form label-width="90px" label-position="right" label-suffix="" :model="project" :rules="rules">
        <el-row :gutter="10">
          <el-col :span="6">
            <el-form-item label="质保期限">
              <el-input
                maxlength="11"
                v-model="project.warrantyPeriod"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="履约保证金">
              <el-input
                maxlength="11"
                v-model="project.performanceBond"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="质量保证金">
              <el-input
                maxlength="11"
                v-model="project.depositAmount"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item label="合同金额" prop="contractAmount">
              <el-input
                maxlength="30"
                v-model="project.contractAmount"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="金额1">
              <el-input
                maxlength="30"
                v-model="project.contractAmount1"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="金额2">
              <el-input
                maxlength="30"
                v-model="project.contractAmount2"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="金额3">
              <el-input
                maxlength="30"
                v-model="project.contractAmount3"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="金额4">
              <el-input
                maxlength="30"
                v-model="project.contractAmount4"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="金额5">
              <el-input
                maxlength="30"
                v-model="project.contractAmount5"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item label="支付金额">
              <el-input
                maxlength="30"
                v-model="project.paymentAmount"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="金额1">
              <el-input
                maxlength="30"
                v-model="project.paymentAmount1"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="金额2">
              <el-input
                maxlength="30"
                v-model="project.paymentAmount2"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="金额3">
              <el-input
                maxlength="30"
                v-model="project.paymentAmount3"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="金额4">
              <el-input
                maxlength="30"
                v-model="project.paymentAmount4"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="金额5">
              <el-input
                maxlength="30"
                v-model="project.paymentAmount5"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item label="开票金额">
              <el-input
                maxlength="30"
                v-model="project.invoiceAmount"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="金额1">
              <el-input
                maxlength="30"
                v-model="project.invoiceAmount1"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="金额2">
              <el-input
                maxlength="30"
                v-model="project.invoiceAmount2"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="金额3">
              <el-input
                maxlength="30"
                v-model="project.invoiceAmount3"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="金额4">
              <el-input
                maxlength="30"
                v-model="project.invoiceAmount4"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="金额5">
              <el-input
                maxlength="30"
                v-model="project.invoiceAmount5"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="defualt" @click="dialogVisibleCw = false">取消</el-button>
        <el-button type="primary" @click="saveProject">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog height="600" :title="dlg_title" :visible.sync="dialogVisibleForInitialQuota" class="guest-dlg" :close-on-click-modal="false">
      <el-form label-width="90px" label-position="left" label-suffix="" :model="quota">
        <el-row type="flex" :gutter="20" v-for="(value,key) in quota" :key="key">
          <el-col :span="6">
            <el-form-item :label="key">
              <el-input
                maxlength="50"
                v-model="quota[key]"
                auto-complete="off"
                size="mini"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="defualt" @click="defaultInitialQuota">默认值</el-button>
        <el-button type="defualt" @click="dialogVisibleForInitialQuota = false">取消</el-button>
        <el-button type="primary" @click="saveProjectQuota">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog height="600"  :visible.sync="dialogVisible1" class="guest-dlg">
      <div style="display: flex;justify-content: flex-start;">
        <el-button type="primary" icon="el-icon-plus" size="mini" @click="addUser">添加</el-button>
      </div>
      <el-table
        ref="multipleTable"
        :data="members"
        tooltip-effect="dark"
        style="width: 100%;overflow-x: hidden; overflow-y: hidden;"
        max-height="560"
        @selection-change="handleSelectionChange"
        v-loading="loading"
      >
        <el-table-column type="selection" width="60" align="left" v-if="showEdit || showDelete"></el-table-column>
        <el-table-column prop="loginName" label="姓名" width="240" align="center" @click="itemClick"></el-table-column>
        <el-table-column prop="unit" label="状态" width="120" align="center"></el-table-column>
        <el-table-column prop="contractNo" label="岗位" width="120" align="center"></el-table-column>
        <el-table-column label="操作" align="center" v-if="showEdit || showDelete">
          <template slot-scope="scope">
            <el-popconfirm
              placement="top"
              width="160"
              icon="el-icon-info"
              iconColor="red"
              title="确定要删除吗？"
              @onConfirm="remove_member(scope.row.id)">
              <div style="text-align: right; margin: 0">
                <el-button size="mini" type="text" @click="del_confirm_visible = false">取消</el-button>
                <el-button type="primary" size="mini" @click="del_confirm_visible = false">确定</el-button>
              </div>
                <el-button size="mini" type="danger" v-if="showDelete" slot="reference" @click="del_confirm_visible=true">移除本项目</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <div class="guest_table_footer">
        <span></span>
        <el-pagination
          background
          :page-size="pageSize"
          layout="prev, pager, next"
          :total="totalCount"
          @current-change="currentChange"
          v-show="this.projects&&this.projects.length>0"
        ></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="defualt" @click="dialogVisible1 = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog height="600" :visible.sync="dialogVisible2" class="guest-dlg">
      <el-table
        ref="multipleTable"
        :data="users"
        tooltip-effect="dark"
        style="width: 100%;overflow-x: hidden; overflow-y: hidden;"
        max-height="560"
        @selection-change="handleSelectionChange"
        v-loading="loading"
      >
        <el-table-column type="selection" width="60" align="left" v-if="showEdit || showDelete"></el-table-column>
        <el-table-column prop="loginName" label="姓名" width="240" align="center" @click="itemClick"></el-table-column>
        <el-table-column prop="unit" label="状态" width="120" align="center"></el-table-column>
        <el-table-column prop="contractNo" label="岗位" align="center"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="defualt" @click="selectUser()">确认</el-button>
        <el-button type="defualt" @click="dialogVisible2 = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-drawer
      direction="rtl"
      show-close
      size="80%"
      :visible.sync="affixManageForm.dialog_visible"
      :destroy-on-close="true"
    >
       <h4>附件管理</h4>
      <affix-manage :projectId="affixManageForm.projectId"></affix-manage>
    </el-drawer>
  </el-container>
</template>
<script>
import { getRequest, postRequest } from '../../utils/api'
import { HttpStatus } from '../../utils/httpstatus'
import AffixManage from './components/AffixManage.vue'

export default {
  components: { AffixManage },
  mounted () {
    this.stage = this.params.type
    this.loading = true
    this.loadProjectList()
    this.loadProjectManagers()
    this.loadProjectLeaders()
    this.loaddepts()
  },
  props: {
    params: {
      type: Object
    }
  },
  data () {
    return {
      rules: {
        contractAmount: [
          {
            pattern: /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/,
            message: '请输入金额数字，最多两位小数',
            trigger: 'change'
          }
        ]
      },
      stage: 0,
      depts: [],
      projects: [],
      projectManagers: [],
      projectLeaders: [],
      loading: false,
      pageSize: 500,
      totalCount: 0,
      currentPage: 1,
      selItems: [],
      name: '',
      unit: '',
      showEdit: true,
      showDelete: true,
      affixManageForm: {
        projectId: 0,
        dialog_visible: false
      },
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisibleCw: false,
      dialogVisibleForInitialQuota: false,
      del_confirm_visible: false,
      sel_del_confirm_visible: false,
      deptId: 0,
      projectId: 0,
      users: [],
      members: [],
      memberIds: '',
      project: {
        id: 0
      },
      quota: {},
      dlg_title: '添加用户',
      genders: [
        {
          label: '男',
          value: 1
        },
        {
          label: '女',
          value: 2
        }
      ],
      status: [
        {id: 0, name: '待处理'},
        {id: 1, name: '正在进行'},
        {id: 2, name: '暂停'},
        {id: 3, name: '放弃'},
        {id: 4, name: '完成'}
      ],
      projectType: [
        {id: 0, name: '未分类'},
        {id: 1, name: '文书档案数字化'},
        {id: 2, name: '人事档案数字化'},
        {id: 3, name: '文书档案整理'},
        {id: 4, name: '其他项目'}
      ],
      procurementMethods: [
        {id: 1, name: '内部比价'},
        {id: 2, name: '竞争性谈判'},
        {id: 3, name: '竞争性磋商'},
        {id: 4, name: '公开招标'}
      ],
      contractStatus: [
        {id: 0, name: '待签'},
        {id: 1, name: '已签'}
      ],
      biddingStatus: [
        {id: 0, name: '未支付'},
        {id: 1, name: '已支付'}
      ],
      stages: [
        {id: 0, name: '待处理'},
        {id: 1, name: '跟踪'},
        {id: 2, name: '采购'},
        {id: 5, name: '正在执行'},
        {id: 6, name: '验收'},
        {id: 7, name: '归档'}
      ],
      acceptanceStatus: [
        {id: 0, name: '待验收'},
        {id: 1, name: '未通过'},
        {id: 2, name: '已通过'}
      ],
      acceptanceDoc: [
        {id: 0, name: '缺失'},
        {id: 1, name: '验收报告'},
        {id: 2, name: '验收文档'},
        {id: 3, name: '验收报告+验收文档'}
      ]
    }
  },
  methods: {
    genderName (gender) {
      return gender === 2 ? '女' : '男'
    },
    loaddepts () {
      let _this = this
      getRequest('/dept').then(
        resp => {
          this.depts = resp.data
        },
        resp => {
          _this.$message.error('网络连接错误')
          _this.loading = false
        }
      )
    },
    loadProject () {
      let _this = this
      getRequest('/project/index/' + this.projectId).then(
        resp => {
          this.project = resp.data
        },
        resp => {
          _this.$message.error('网络连接错误')
          _this.loading = false
        }
      )
    },
    loadUsers () {
      let _this = this
      getRequest('/user/list?deptId=' + this.deptId).then(
        resp => {
          this.users = resp.data.data.users
        },
        resp => {
          _this.$message.error('网络连接错误')
          _this.loading = false
        }
      )
    },
    loadProjectManagers () {
      let _this = this
      getRequest('/user/list?grade=4').then(
        resp => {
          this.projectManagers = resp.data.data.users
          _this.loading = false
        },
        resp => {
          _this.$message.error('网络连接错误')
          _this.loading = false
        }
      )
    },
    loadProjectLeaders () {
      let _this = this
      getRequest('/user/list?grade=3&deptId=' + this.deptId).then(
        resp => {
          this.projectLeaders = resp.data.data.users
          _this.loading = false
        },
        resp => {
          _this.$message.error('网络连接错误')
          _this.loading = false
        }
      )
    },
    loadProjectList () {
      const _this = this
      var url = '/project/list?page=' + _this.currentPage + '&pageSize=' + _this.pageSize
      if (_this.name !== '') {
        url += '&name=' + _this.name
      }
      if (_this.unit !== '') {
        url += '&unit=' + _this.unit
      }
      if(_this.stage!==undefined && _this.stage !== ''){
        url += '&stage=' + _this.stage
      }
      if(_this.deptId !==''){
        url += '&deptId=' + _this.deptId
      }
      getRequest(url).then(
        resp => {
          _this.projects = resp.data.data.projects
          _this.totalCount = resp.data.data.totalCount
          _this.deptId = resp.data.data.deptId
          _this.loading = false
        },
        resp => {
          _this.$alert('网络连接错误')
          _this.loading = false
        }
      )
    },
    addProject () {
      this.loadUsers()
      this.dialogVisible = true
      this.project = {}
      this.dlg_title = '添加项目'
    },
    editProject (type) {
      if (this.selItems.length !== 1) {
        this.$alert('请选择一行数据')
        return
      }
      var row = this.selItems[0]
      console.log(this.set)
      this.deptId = row.dept
      this.loadUsers()
      if (type === 1) {
        this.dialogVisible = true
      } else if (type === 2) {
        this.dialogVisibleCw = true
      }
      // this.project = {}
      this.projectId = row.id
      this.loadProject()
      this.dlg_title = '编辑项目信息'
      this.project.gender = row.gender ? parseInt(row.gender) : 1
    },
    saveProject () {
      const _this = this
      if (this.project.location == null) {
        delete this.project.location
      }
      postRequest('project/add', this.project).then(resp => {
        if (resp.data.status === HttpStatus.OK) {
          _this.$alert(resp.data.msg)
          _this.dialogVisible = false
          this.loadProjectList()
        } else {
          _this.$alert(resp.data.msg)
        }
      },
      resp => {
        _this.$alert('网络错误，请重试')
      })
    },
    saveProjectQuota () {
      const _this = this
      _this.quota.quotaList = JSON.stringify(this.quota)
      _this.quota.projectId = _this.projectId
      postRequest('/project/addQuota', this.quota).then(resp => {
        if (resp.data.status === HttpStatus.OK) {
          _this.$alert(resp.data.msg)
          _this.dialogVisibleForInitialQuota = false
        } else {
          _this.$alert(resp.data.msg)
        }
      },
      resp => {
        _this.$alert('网络错误，请重试')
      })
    },
    defaultInitialQuota () {
      const _this = this
      var row = _this.selItems[0]
      getRequest('/project/loadDefaultQuota/' + row.type).then(resp => {
        if (resp.data.status === HttpStatus.OK) {
          _this.quota = resp.data.data
        } else {
          _this.$alert(resp.data.msg)
        }
      },
      resp => {
        _this.$alert('网络错误，请重试')
      })
    },
    del_project () {
      let _this = this
      if (_this.selItems.length !== 1) {
        _this.$alert('请选择一行数据')
        return
      }
      getRequest('/project/del/' + this.selItems[0].id).then(
        resp => {
          if (resp.data.data) {
            _this.$message.success(resp.data.msg)
            this.loadProjectList()
          } else {
            _this.$message.error(resp.data.msg)
          }
        },
        resp => {
          _this.$message.error('网络连接错误')
          _this.loading = false
        }
      )
    },
    handleSelectionChange (val) {
      this.selItems = val
    },
    memberManage () {
      var row = this.selItems[0]
      this.deptId = row.dept
      this.project = row
      this.projectId = row.id
      this.members = []
      this.loadMember()
      this.dialogVisible1 = true
      this.dlg_title = '项目成员管理'
      this.project.gender = row.gender ? parseInt(row.gender) : 1
    },
    initialQuotaManage () {
      var row = this.selItems[0]
      this.dialogVisibleForInitialQuota = true
      this.projectId = row.id
      this.dlg_title = '编辑项目信息'
      this.quota = null
      this.loadProjectQuota()
    },
    loadMember () {
      let _this = this
      getRequest('/project/memberList/' + this.projectId).then(
        resp => {
          this.members = resp.data.data.users
        },
        resp => {
          _this.$message.error('网络连接错误')
          _this.loading = false
        }
      )
    },
    addUser () {
      this.loadUsers()
      this.dialogVisible2 = true
      this.dlg_title = '用户列表'
    },
    searchClick () {
      this.loadProjectList()
    },
    itemClick (row) {
      this.handleEdit(0, row)
      // this.$router.push({ path: '/blogDetail', query: { aid: row.id } })
    },
    currentChange (currentPage) {
      this.currentPage = currentPage
      this.loading = true
      this.loadProjectList()
    },
    selectUser () {
      let _this = this
      let ids = []
      this.$refs.multipleTable.selection.map((item) => {
        ids.push(item.id)
      })
      getRequest('/project/setMember/' + this.projectId + '/' + ids).then(
        resp => {
          _this.$message.success('操作成功')
          _this.loadMember()
          _this.loadProjectList()
          this.dialogVisible2 = false
        },
        resp => {
          _this.$message.error('网络连接错误')
          _this.loading = false
        }
      )
    },
    remove_member (id) {
      let _this = this
      getRequest('/project/removeMember/' + this.projectId + '/' + id).then(
        resp => {
          _this.$message.success('操作成功')
          _this.loadMember()
          _this.loadProjectList()
        },
        resp => {
          _this.$message.error('网络连接错误')
          _this.loading = false
        }
      )
    },
    loadProjectQuota () {
      const _this = this
      getRequest('/project/loadQuota/' + this.projectId).then(resp => {
        if (resp.data.status === HttpStatus.OK) {
          _this.quota = resp.data.data
        } else {
          _this.$alert(resp.data.msg)
        }
      },
      resp => {
        _this.$alert('网络错误，请重试')
      })
    },
    showAffixManageDialog () {
      if (this.selItems.length !== 1) {
        this.$alert('请选择一行数据')
        return
      }
      this.affixManageForm.dialog_visible = true
      this.affixManageForm.projectId = this.selItems[0].id
    }
  }
}
</script>
<style>
.row_header {
  color:#409EFF;
  margin: 20px auto;
  text-align: left;
}
.row_header > h2 {
  font-size: 18px;
  font-weight: 800;
}
.guest-dlg {
  color: #000;
  font-size: 14px;
}
.guest_table_footer {
  display: flex;
  box-sizing: content-box;
  padding-top: 10px;
  padding-bottom: 0px;
  margin-bottom: 0px;
  justify-content: space-between;
}
.project_list > .header {
  background-color: #ececec;
  margin-top: 10px;
  padding-left: 5px;
  display: flex;
  justify-content: flex-start;
}

.aproject_list > .main {
  /*justify-content: flex-start;*/
  display: flex;
  flex-direction: column;
  padding-left: 0px;
  background-color: #fff;
  padding-top: 0px;
  margin-top: 8px;
}
el-form:last-child {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/Views/Project/ProjectMana.vue